import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";

export const corporateAddEmployeeAPI = createAsyncThunk(
    "corporateAddEmployeeAPI",
    async (data, { rejectWithValue }) => {
        try {
            const id = data.get('id')
            const response = await api.post(endpoints.coporateAddEmploye(id), data)
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const corporateShowEmployeesAPI = createAsyncThunk(
    "corporateShowEmployeesAPI",
    async (data, { rejectWithValue }) => {
        try {
            const id = data?.id;
            const page = data?.page;
            const response = await api.get(endpoints.coporateShowEmployees(id, page));
            return response.data;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

export const corporateShowSingleEmployeesAPI = createAsyncThunk(
    "corporateShowSingleEmployeesAPI",
    async ({ user, employee_id }, { rejectWithValue }) => {
        try {
            const id = user?.id;
            const response = await api.get(endpoints.coporateShowSingleEmployees(id, employee_id));
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

export const corporateUpdateEmployeeAPI = createAsyncThunk(
    "corporateUpdateEmployeeAPI",
    async ({ data, employee_id }, { rejectWithValue }) => {
        try {
            const id = data.get("user_id");
            const response = await api.post(endpoints.coporateUpdateEmployees(id, employee_id), data);
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

export const corporateEmployeeStatusAPI = createAsyncThunk(
    "corporateEmployeeStatusAPI",
    async ({ coporate_id, employee_id, status }, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.coporateEmployeesStatus(coporate_id, employee_id, status));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);


const initialState = {
    loading: false,
    employeeLoading: false,
    updateEmployeeloading: false,
    allEmployees: [],
    singleUserDetial: "",
    pagination: {
        current_page: 1,
        total_pages: 1,
    },
}

const coporateAddEmployeSlice = createSlice({
    initialState,
    name: "coporateAddEmployeSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(corporateAddEmployeeAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(corporateAddEmployeeAPI.fulfilled, (state, action) => {
            state.loading = false
        })

        builder.addCase(corporateAddEmployeeAPI.rejected, (state, action) => {
            state.loading = false;
        })

        // SHOW EMPLOYEE

        builder.addCase(corporateShowEmployeesAPI.pending, (state, action) => {
            state.employeeLoading = true
        })

        builder.addCase(corporateShowEmployeesAPI.fulfilled, (state, action) => {
            state.employeeLoading = false;
            state.allEmployees = action.payload.data.data;
            state.pagination = {
                current_page: action.payload.data.current_page,
                total_pages: action.payload.data.last_page,
            };
        })

        builder.addCase(corporateShowEmployeesAPI.rejected, (state, action) => {
            state.employeeLoading = false;
            const errors = action.payload?.errors;
            if (errors) {
                Object.values(errors).forEach((errorArray) => {
                    errorArray.forEach((message) => {
                        toast.error(message);
                    });
                });
            } else {
                const defaultMessage = action.payload?.message || "Something went wrong. Invalid Data.";
                toast.error(defaultMessage);
            }
        })

        // SHOW SINGLE EMPLOYEE

        builder.addCase(corporateShowSingleEmployeesAPI.pending, (state, action) => {
            state.employeeLoading = true
        })

        builder.addCase(corporateShowSingleEmployeesAPI.fulfilled, (state, action) => {
            state.employeeLoading = false;
            state.singleUserDetial = action?.payload?.data?.data
        })

        builder.addCase(corporateShowSingleEmployeesAPI.rejected, (state, action) => {
            state.employeeLoading = false;
            const errors = action.payload?.errors;
            if (errors) {
                Object.values(errors).forEach((errorArray) => {
                    errorArray.forEach((message) => {
                        toast.error(message);
                    });
                });
            } else {
                const defaultMessage = action.payload?.message || "Something went wrong. Invalid Data.";
                toast.error(defaultMessage);
            }
        })

        // UPDATE EMPLOYEE
        builder.addCase(corporateUpdateEmployeeAPI.pending, (state, action) => {
            state.updateEmployeeloading = true
        })

        builder.addCase(corporateUpdateEmployeeAPI.fulfilled, (state, action) => {
            state.updateEmployeeloading = false;
        })

        builder.addCase(corporateUpdateEmployeeAPI.rejected, (state, action) => {
            state.loupdateEmployeeloadingading = false;
            // const errors = action.payload?.errors;
            // if (errors) {
            //     Object.values(errors).forEach((errorArray) => {
            //         errorArray.forEach((message) => {
            //             toast.error(message);
            //         });
            //     });
            // } else {
            //     const defaultMessage = action.payload?.message || "Something went wrong. Invalid Data.";
            //     toast.error(defaultMessage);
            // }
        })
    }
})

export const { } = coporateAddEmployeSlice.actions
export default coporateAddEmployeSlice.reducer